require("custom-event-polyfill");
require("./js/prepopulate.js");
require("./js/common/validator.js");
require("./js/common/form-labels.js");
require("./js/app.js");
require("./style.scss");
require("./js/common/collapsible.js");

$(function () {
	$("[data-click-tracking-url]").click(function () {
		var clickUrl = $(this).data("click-tracking-url");
		$("body").append('<img src="' + clickUrl + '" style="display:none;"></img>');
	});
});